// One-time intro banner shown when a user first lands on the new Insights (visual)
// answer UI. Visually consistent with the concept-test intro banner (`vct-banner`):
// sparkles circle icon + bold title + subtitle + teal CTA + ghost dismiss ×, with a
// teal-soft fill, a 3px left teal accent, and a subtle slide-up entrance.

import { Sparkles, X } from 'lucide-react';

interface Props {
  onTakeTour: () => void;
  onDismiss: () => void;
}

const NewUIBanner: React.FC<Props> = ({ onTakeTour, onDismiss }) => (
  <div className="flex justify-center mb-5 animate-fade-in" data-tour="insights-banner">
    <div
      role="status"
      className="w-full flex items-center gap-3 px-3.5 py-3 rounded-xl bg-[#E8FCFA] border border-[#07E5D1]/30 border-l-[3px] border-l-[#07E5D1] shadow-sm"
    >
      <span className="flex-shrink-0 inline-flex items-center justify-center w-[30px] h-[30px] rounded-full bg-white border border-[#07E5D1]/40 text-[#07E5D1]">
        <Sparkles size={15} />
      </span>
      <p className="flex-1 m-0 text-[13.5px] leading-[1.45] text-[#374151]">
        <strong className="text-[#1C1C1E] font-semibold">
          You&apos;re trying our new Insights UI.
        </strong>{' '}
        Answers now render as a visual report — switch between Insights and Text Analysis any time.
        Tell us what you think.
      </p>
      <button
        onClick={onTakeTour}
        className="flex-shrink-0 bg-[#07E5D1] hover:bg-[#02B9A8] text-white text-[13px] font-semibold px-3.5 py-1.5 rounded-md transition-colors"
      >
        Take a quick tour
      </button>
      <button
        onClick={onDismiss}
        aria-label="Dismiss"
        className="flex-shrink-0 w-7 h-7 inline-flex items-center justify-center rounded-md text-[#6B7280] hover:text-[#1C1C1E] hover:bg-black/[0.04] transition-colors"
      >
        <X size={14} />
      </button>
    </div>
  </div>
);

export default NewUIBanner;
